module.exports = __webpack_public_path__ + "static/media/twitter.b9ab4866.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-icons/twitter.svg
// module id = 861
// module chunks = 0